import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useLayoutStore = defineStore('core-layout', () => {
  const userDrawerOpen = ref(false)

  function openUserDrawer() {
    userDrawerOpen.value = true
  }

  function closeUserDrawer() {
    userDrawerOpen.value = false
  }

  function toggleUserDrawer() {
    userDrawerOpen.value = !userDrawerOpen.value
  }

  return {
    userDrawerOpen,
    openUserDrawer,
    closeUserDrawer,
    toggleUserDrawer,
  }
})
